import { VehicleUseType } from '@/common/queries/selections/vehicleUse/vehicleUse.type';
import { InsuranceABV } from '@/common/types/SelectionOptions.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehicleUseFunction = ({
  insurance,
  type,
}: {
  insurance: InsuranceABV;
  type: string;
}): Promise<VehicleUseType[]> => {
  return fetchApi.get('/selection_item/vehicle_use/wop_list/', {
    params: { insurance, type },
  });
};
